export const NO_DATA_CARD = "NoDataCard";
export const NO_DATA_TITLE_ID = "NoDataTitleId";
export const NO_DATA_SUBTITLE_ID = "NoDataSubtitleId";
